import { useState } from 'react'
import { Modal, Button } from 'antd'
import useTranslation from '@/hooks/useTranslation'
import { useDispatch, useSelector } from 'react-redux'
import {
  updatePassword,
  clearError,
} from '../../../features/auth/apis/authSlice'
import { errorHandling, openNotification } from '../../../utils/utils'

import PasswordInput from '../form/PasswordInput'
import Close from '../../svgs/CloseModal'

export default function UpdatePassword({ open, setOpen }) {
  const { t } = useTranslation()
  const dispatch = useDispatch()

  const { updateLoading, profile } = useSelector((state) => state.auth)

  const [formValues, setFormValues] = useState({
    _method: 'PUT',
    new_password: '',
    new_password_confirmation: '',
  })

  // HANDLE SUBMIT
  const handleSubmit = () => {
    dispatch(updatePassword(formValues))
      .unwrap()
      .then((data) => {
        openNotification('success', data.message)
        setOpen(false)
      })
      .catch((error) => {
        const message = errorHandling(error)
        openNotification('error', message)
      })
  }

  return (
    <Modal
      className='!w-[30rem]'
      title={null}
      open={open}
      onCancel={() => {
        setOpen(false)
        dispatch(clearError())
      }}
      footer={null}
      closable={false}
      centered
    >
      <div className='text-center mb-24 mt-16'>
        <h3 className='text-xl font-semibold capitalize mb-8'>
          {t('Create New Password')}
        </h3>
      </div>

      <div className='form-type_5'>
        {!profile?.provider && (
          <PasswordInput
            label={`${t('Old Password')}*`}
            placeholder={t('form.password.ph')}
            name='old_password'
            autoComplete='current-password'
            value={formValues.password}
            onChange={(e) =>
              setFormValues({ ...formValues, old_password: e.target.value })
            }
            style='mb-16'
          />
        )}
        <PasswordInput
          label={`${t('form.password.label')}*`}
          placeholder={t('form.password.ph')}
          name='new_password'
          autoComplete='new-password'
          value={formValues.new_password}
          onChange={(e) =>
            setFormValues({ ...formValues, new_password: e.target.value })
          }
          style='mb-16'
        />
        <PasswordInput
          label={`${t('New Password Confirmation')}*`}
          placeholder={t('form.password.ph')}
          name='new_password_confirmation'
          autoComplete='new-password'
          value={formValues.new_password_confirmation}
          onChange={(e) =>
            setFormValues({
              ...formValues,
              new_password_confirmation: e.target.value,
            })
          }
        />
      </div>

      <Button
        className='btn-green text-base font-semibold tracking-wide rounded-lg py-12 w-full h-auto mt-24'
        loading={updateLoading}
        onClick={handleSubmit}
      >
        {t('Confirm')}
      </Button>

      <Close
        style='absolute top-28 right-36 cursor-pointer'
        onClick={() => {
          setOpen(false)
          dispatch(clearError())
        }}
      />
    </Modal>
  )
}
